<template>
  <div class="content-container">
    <el-form
      :inline="true"
      :model="formInline"
      class="demo-form-inline"
      label-width="100px"
    >
      <!-- <el-form-item label="故障编号">
        <el-input
          v-model="formInline.troubleid"
          placeholder="请输入故障编号"
        ></el-input> 
      </el-form-item>-->
      <el-form-item label="订单号">
        <el-input
          v-model="formInline.orderid"
          placeholder="请输入订单号"
        ></el-input>
      </el-form-item>
      <!-- <el-form-item label="故障类型">
        <el-input
          v-model="formInline.troubleType"
          placeholder="请输入故障类型"
        ></el-input> 
      </el-form-item>-->
      <!-- <el-form-item label="故障描述">
        <el-input
          v-model="formInline.troubleDetail"
          placeholder="请输入故障描述"
        ></el-input>
      </el-form-item> -->
      <el-form-item label="用户名">
        <el-input
          v-model="formInline.username"
          placeholder="请输入用户名"
        ></el-input>
      </el-form-item>
      <el-form-item label="手机号">
        <el-input
          v-model="formInline.usermobile"
          placeholder="请输入手机号"
        ></el-input>
      </el-form-item>
      <el-form-item label="额外的手机号">
        <el-input
          v-model="formInline.secondmobile"
          placeholder="请输入额外的手机号"
        ></el-input>
      </el-form-item>
      <!-- <el-form-item label="起止时间">
        <el-date-picker
          v-model="formInline.modifiedtime"
          type="daterange"
          range-separator="~"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item> -->
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="onSubmit"
          >查询</el-button
        >
      </el-form-item>
      <el-button
        type="primary"
        icon="el-icon-check"
        @click="onBatchSetRead"
        :disabled="multipleSelection.length === 0"
        >批量设置已读</el-button
      >
    </el-form>

    <el-table
      :data="tableData"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <!-- <el-table-column prop="troubleid" label="故障编号"></el-table-column> -->
      <el-table-column type="selection" width="55"></el-table-column>

      <el-table-column
        width="100"
        prop="machineTroubleEntity.troubleid"
        label="troubleid"
      ></el-table-column>

      <el-table-column label="订单号">
        <template slot-scope="scope">
          <router-link
            class="link-div"
            tag="div"
            :to="{
              name: 'order',
              query: { orderid: scope.row.machineTroubleEntity.orderid }
            }"
            >{{ scope.row.machineTroubleEntity.orderid }}</router-link
          >
        </template>
      </el-table-column>
      <!-- <el-table-column prop="troubleType" label="故障类型"></el-table-column> -->

      <el-table-column
        prop="machineTroubleEntity.troubleDetail"
        label="故障描述"
      ></el-table-column>
      <el-table-column prop="machineTroubleEntity.username" label="用户名">
        <template slot-scope="scope">
          <div v-html="scope.row.machineTroubleEntity.username"></div>
        </template>
      </el-table-column>
      <el-table-column
        prop="machineTroubleEntity.usermobile"
        label="手机号"
      ></el-table-column>
      <el-table-column
        prop="machineTroubleEntity.secondmobile"
        label="额外的手机号"
      ></el-table-column>
      <el-table-column
        prop="machineTroubleEntity.status"
        label="状态"
        width="70px"
      >
        <template slot-scope="scope">
          <el-tag
            type="info"
            effect="dark"
            v-if="scope.row.machineTroubleEntity.status == 1"
            >已读</el-tag
          >
          <el-tag
            type="warning"
            effect="dark"
            v-else-if="scope.row.machineTroubleEntity.status == 0"
            >未读</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column label="创建时间">
        <template slot-scope="scope">
          <div>
            {{ scope.row.machineTroubleEntity.createtime | formatDateTime }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="修改时间">
        <template slot-scope="scope">
          <div>
            {{ scope.row.machineTroubleEntity.modifiedtime | formatDateTime }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <!-- <el-button type="text" @click="handleDelete(scope.row)"
            >处理</el-button
          > -->
          <el-button
            type="text"
            @click="imgDetail(scope.$index)"
            v-if="scope.row.machineTroubleImageEntities.length > 0"
            >查看图片</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      @current-change="handleCurrentChange"
      :current-page.sync="page.currentPage"
      :page-size="page.pageSize"
      layout="total, prev, pager, next"
      :total="page.total"
    ></el-pagination>
    <el-dialog title="查看图片" :visible.sync="dialogVisible" width="900px">
      <el-carousel trigger="click" height="640px">
        <el-carousel-item v-for="(item, index) in imageList" :key="index">
          <img class="movie-img" :src="item" alt="" srcset="" />
        </el-carousel-item>
      </el-carousel>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      formInline: {
        troubleid: "",
        orderid: "",
        troubleType: "",
        troubleDetail: "",
        username: "",
        usermobile: "",
        secondmobile: "",
        modifiedtime: ""
      },
      multipleSelection: [],
      tableData: [],
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      dialogVisible: false,
      imageList: [],
      machineTroubleList: []
    };
  },
  methods: {
    onSubmit() {
      let queryModel = {
        troubleid: this.formInline.troubleid,
        orderid: this.formInline.orderid,
        troubleType: this.formInline.troubleType,
        troubleDetail: this.formInline.troubleDetail,
        username: this.formInline.username,
        usermobile: this.formInline.usermobile,
        secondmobile: this.formInline.secondmobile,
        modifiedtimeFrom: Array.isArray(this.formInline.modifiedtime)
          ? this.$ToDateString(this.formInline.modifiedtime[0])
          : null,
        modifiedtimeTo: Array.isArray(this.formInline.modifiedtime)
          ? this.$ToDateStringToDateString(this.formInline.modifiedtime[1])
          : null,
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize
      };
      this.$axios(this.$urlMapping["查询机器故障"], {
        data: queryModel
      }).then(result => {
        // this.tableData = result.data.map(ele => ele.machineTroubleEntity);
        this.machineTroubleList = result.data;
        this.tableData = result.data;
        this.page.total = result.totalCount;
        this.page.currentPage = result.pageNum;
      });
    },
    handleCurrentChange(currentPage) {
      this.page.currentPage = currentPage;
      this.onSubmit();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    onBatchSetRead() {
      this.$confirm("是否确认设置成已读?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let troubleids = this.multipleSelection.map(
          ele => ele.machineTroubleEntity.troubleid
        );
        console.log(troubleids);
        this.$axios(this.$urlMapping["设置报障已读"], {
          data: {
            troubleids
          }
          // eslint-disable-next-line no-unused-vars
        }).then(result => {
          this.$notifySuccess();
          this.onSubmit();
        });
      });
    },

    onAdd() {},
    closeForm() {},
    onBatchDelete() {},
    imgDetail(index) {
      //alert(index);
      this.imageList = [];
      this.$nextTick(() => {
        this.imageList = this.machineTroubleList[
          index
        ].machineTroubleImageEntities.map(
          ele => "/api/shared/getImage?ossFileKey=" + ele.key
        );
        this.dialogVisible = true;
      });
    }
  },
  mounted() {
    console.log(this.$route.query.troubleid);

    if (this.$route.query.troubleid) {
      this.formInline.troubleid = this.$route.query.troubleid;
    }

    this.onSubmit();
  }
};
</script>

<style lang="less" scoped>
.movie-img {
  height: 100%;
}
.el-carousel__item {
  text-align: center;
}
</style>
